import { ar } from "./ar";
import { en } from "./en";
export const messages = {
  en,
  ar,
};
export function transformKey(key) {
  return key
    .split(".")
    .pop()
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
}
